<div class="notification-wrapper" (click)="toggleDropdown()">
  <img
    src="../../../assets/images/notification_bell.png"
    class="notification-img111"
    alt="notification_img"
    *ngIf="!isHomePageNotScrolled"
    height="35" width="35"
  />
  <img
    src="../../../assets/images/bell-white.png"
    class="notification-img111"
    alt="notification_img"
    *ngIf="isHomePageNotScrolled"
    height="35" width="35"
  />

  <!-- Dropdown -->
  <div class="notification-dropdown" *ngIf="showDropdown">
    <div *ngFor="let item of notificationList" class="notification-item">
        <div>
            <img src="../../../assets/images/notification-page-icon.png" class="notification-img" alt="notification_img" height="40" width="40"/>
        </div>
        <div>
            <p class="notification_title">{{item?.topic}}</p>
            <p class="notification-description">{{item?.message}}</p>
            <!-- <small>time here</small> -->
        </div>
    </div>
    <div style="text-align: center; margin-top: 10px;" *ngIf="notificationList.length > 0">
        <button class="btn btn-warning view-all-btn" type="button" (click)="handleViewAll()">View All</button>
    </div>

    <div *ngIf="notificationList.length === 0" class="no-notification">
        No notifications available.
    </div>

  </div>
</div>
